import React from 'react';
import { Modal, Flex, Button } from 'src/kit';
import { Title } from '../atoms';

export const ConfirmationModal = ({ title, onClose, onCancel, onConfirm }) => (
  <Modal onClose={onClose}>
    <Title>{title}</Title>
    <Flex justifyContent="flex-end">
      <Button onClick={onCancel} mr={20} variant="cancel" size="md">
        No
      </Button>
      <Button onClick={onConfirm} variant="primary" size="md" width="auto">
        Yes
      </Button>
    </Flex>
  </Modal>
);
